var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-coupons-warp"},[_c('img',{attrs:{"src":require("../assets/img/couponsBg2.jpg")}}),_c('div',{staticClass:"coupons-get-btn",on:{"click":_vm.getCoupon}}),(_vm.isLoading)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }